export default __webpack_public_path__ + "static/logo-7-839e0b2972145e16dbde685dc58624c2.webp";